import React from 'react';
import PropTypes from 'prop-types';
import EN from '../../../EN.json';
import FR from '../../../FR.json';
import { useLocaleContext } from '../../context/LocaleContext';
import { ViewOrderHeader } from '../dashboardCommon';
import 'react-datepicker/dist/react-datepicker.css';

const fieldMapping = {
  orderId: 'orderId',
  businessName: 'legalBusinessNameFMSOW',
  status: 'status'
};

const ViewOrderHeaderFMSOW = ({ orderData }) => {
  const locale = useLocaleContext();
  const {
    ORDERS: { orderId, businessName },
    dashboardSOW: { statusText },
    DEFECT_MANAGEMENT: { STATUS }
  } = locale === 'en-US' ? EN : FR;

  const labels = {
    orderIdLabel: orderId,
    businessNameLabel: businessName,
    statusLabel: STATUS,
    statusTextMap: statusText
  };

  return (
    <ViewOrderHeader
      orderData={orderData}
      labels={labels}
      fieldMapping={fieldMapping}
    />
  );
};

ViewOrderHeaderFMSOW.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired
};

export default ViewOrderHeaderFMSOW;
